import { inject } from '@angular/core';
import {
  Router,
  CanActivateFn
} from '@angular/router';

import { Auth } from './auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(Auth);
  const router = inject(Router);

  if (auth.loggedIn()) {
    return true;
  } else {
    const url = state && state.url ? state.url : (router?.url || '/');
    router.navigate(['/unauthorized'], {
      queryParams: { state: url }
    });
    return false;
  }
};
